module.exports = __webpack_public_path__ + "img/logoWhite.84fe108c.svg";